import type { Object3D } from 'three';
import type { ExternalGeometrySourceDescriptor } from '../../model/ExternalGeometrySourceDescriptor';
import type { SketchEntityReferenceSelectionIntent } from './SketchEntityReferenceSelectionIntent';
import type {
	SketchEntityReferenceSelectionCandidate,
	SketchEntityReferenceSelectionCandidateSource,
} from '../../../../../types/reference/sketch-entity-reference/SketchEntityReferenceSelectionAdapter';

export type {
	SketchEntityReferenceSelectionCandidate,
	SketchEntityReferenceSelectionCandidateSource,
} from '../../../../../types/reference/sketch-entity-reference/SketchEntityReferenceSelectionAdapter';

/**
 * 解析选择候选实际包含的来源集合。
 *
 * @param candidate 选择候选。
 * @returns 可参与创建的来源集合。
 */
export function resolveSketchEntityReferenceSelectionCandidateSources(
	candidate: SketchEntityReferenceSelectionCandidate,
): SketchEntityReferenceSelectionCandidateSource[] {
	return candidate.relatedSources && candidate.relatedSources.length > 0
		? candidate.relatedSources
		: [{
			descriptor: candidate.descriptor,
			displayLabel: candidate.displayLabel,
			sourceObject: candidate.sourceObject,
			runtimeTopologySource: candidate.runtimeTopologySource,
		}];
}
